<template>
  <div class="flex h-screen flex-col">
    <div class="flex flex-col flex-grow">
      <NavigationBar />
      <slot />
    </div>
    <FooterDefault />
  </div>
</template>
